package navigation.utils

import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.core.screen.uniqueScreenKey
import cafe.adriel.voyager.navigator.Navigator

/**
 * Safe push to avoid pushing the same screen multiple times
 */
fun Navigator.safePush(screen: Screen) {
    if (lastItem.key != screen.key)
        push(screen)
}

fun Navigator.safeReplaceAll(screen: Screen) {
    if (lastItem.key != screen.key)
        replaceAll(screen)
}

/**
 * Safe pop to avoid popping the same screen multiple times
 */
fun Navigator.safePop(currentScreen: Screen) {
    if (lastItem.key == currentScreen.key)
        pop()
}